import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getDataNivel = (query, params) => http.get(`${api}/operation/entrada-mercancia/${params}`, { params: { ...query } })

export {
  getDataNivel
}
